/*
 * Which backend the app talks to, decided by the domain it is opened from:
 *
 *   http://localhost:3000/                                  ->  local servers  (API :3027, OMS :3028)
 *   https://reliancejewels.rril.ril.com/storelocator/...    ->  rril server
 *   https://reliancejewels.com/storelocator/...             ->  production server
 *
 * Any other host falls back to production, as before.
 *
 * Optional overrides (set in .env.local or the build environment, they win over the domain):
 *   REACT_APP_SERVER_PATH   API base, including /api   e.g. http://localhost:3027/api
 *   REACT_APP_OMS_PATH      OMS base, no /api          e.g. http://localhost:3028
 */

const PRODUCTION_ORIGIN = 'https://www.reliancejewels.com'
const RRIL_ORIGIN = 'https://www.reliancejewels.rril.ril.com'

const LOCAL_API = 'http://localhost:3027/api'
const LOCAL_OMS = 'http://localhost:3028'

const hostname = typeof window !== 'undefined' ? window.location.hostname : ''

const isLocal = ['localhost', '127.0.0.1', '::1', '[::1]'].includes(hostname)
const isRril = /(^|\.)rril\.ril\.com$/i.test(hostname)

const defaults = isLocal
    ? { api: LOCAL_API, oms: LOCAL_OMS }
    : isRril
        ? { api: `${RRIL_ORIGIN}/api`, oms: RRIL_ORIGIN }
        : { api: `${PRODUCTION_ORIGIN}/api`, oms: PRODUCTION_ORIGIN }

const withoutTrailingSlash = (url) => String(url).replace(/\/+$/, '')

export const SERVER_PATH = withoutTrailingSlash(process.env.REACT_APP_SERVER_PATH || defaults.api)
export const SERVER_PATH_FOR_OMS = withoutTrailingSlash(process.env.REACT_APP_OMS_PATH || defaults.oms)
